<script setup lang="ts">

interface Props {
  benefits: object[]
}

const props = defineProps<Props>()

const activeIndex = ref(0)
let rotationIntervalId: number | undefined
let initialTimeoutId: number | undefined

const startRotation = () => {
  const firstDelay = 1000
  const regularDelay = 3000

  initialTimeoutId = window.setTimeout(() => {
    activeIndex.value = (activeIndex.value + 1) % props.benefits.length

    rotationIntervalId = window.setInterval(() => {
      activeIndex.value = (activeIndex.value + 1) % props.benefits.length
    }, regularDelay)
  }, firstDelay)
}

onMounted(() => {
  startRotation()
})

onUnmounted(() => {
  if (rotationIntervalId) clearInterval(rotationIntervalId)
  if (initialTimeoutId) clearInterval(initialTimeoutId)
})

</script>

<template>
  <div class="offer-exchange-mobile-benefits">
    <div v-for="(benefit, index) in benefits" :key="benefit?.icon"
         :class="[
             `offer-exchange-benefit offer-exchange-benefit-${index}`,
             index === activeIndex ? `offer-exchange-benefit--active offer-exchange-benefit-${index}--active` : ''
        ]">
      <ui-custom-icon :icon="benefit?.icon" :size="34" color="primary"/>
      <span class="offer-exchange-benefit-text">{{ benefit?.text }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'assets/css/tokens/colors' as *;
@use 'assets/css/tokens/typography' as *;

.offer-exchange-mobile-benefits {
  display: flex;
  gap: clamp(1rem, 3.5vw, 3rem);
  width: 100%;
}

.offer-exchange-benefit {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.25rem;
  padding: 1.25rem;
  border: 1px solid $color-border;
  flex: 0 0 auto;
  transition: flex 2.5s ease, border-radius 2.5s ease, transform 2.5s ease;
  overflow: hidden;
  width: calc(34px + 1.25rem * 2);
  height: calc(34px + 1.25rem * 2);

  @media (max-width: 599px) {
    gap: .25rem;
    padding: .75rem;
    width: calc(34px + .75rem * 2);
    height: calc(34px + .75rem * 2);
  }
}

.offer-exchange-benefit-0 {
  border-radius: 60px 60px 60px 0;
}

.offer-exchange-benefit-1 {
  border-radius: 80px;
}

.offer-exchange-benefit-2 {
  border-radius: 60px 0 60px 60px;
}

.offer-exchange-benefit--active {
  transform: scale(1.05);
  flex: 1 1 auto;
}

.offer-exchange-benefit-0--active {
  border-radius: 26px 60px 60px 0;
}

.offer-exchange-benefit-1--active {
  border-radius: 80px;
}

.offer-exchange-benefit-2--active {
  border-radius: 60px 0 26px 60px;
}

.offer-exchange-benefit-text {
  font-size: $font-size-11;
  line-height: $line-height-14;
  color: $color-dark-grey;
  white-space: nowrap;

  @media (max-width: 599px) {
    opacity: 0;
    white-space: pre;
    transition: opacity 0.6s ease;
  }
}

.offer-exchange-benefit--active .offer-exchange-benefit-text {
  opacity: 1;
}

</style>